<ccl-page-header>
    <div class="s-page-header__left c-page-header__left">
        <div class="c-title c-title--secondary text-capitalize">Additional Settings</div>
    </div>
</ccl-page-header>

<ccl-content-section>
    <div class="row">
        <div class="col-sm-12">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="header">Use the section below to insert scripts or css references into the DOM header</label>
                </div>
                <div ace-editor
                class="form-control ace-editor"
                [mode]="'html'" 
                [theme]="'eclipse'"
                [options]="options"
                [readOnly]="false"
                [autoUpdateContent]="true"
                [(text)]="additionalSetting.header">
                </div>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-12">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="footer">Use the section below to insert scripts or css references into the DOM footer</label>
                </div>
                <div ace-editor
                class="form-control ace-editor"
                [mode]="'html'" 
                [theme]="'eclipse'"
                [options]="options"
               [readOnly]="false"
                [autoUpdateContent]="true"
                [(text)]="additionalSetting.footer"></div>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>
</ccl-content-section>
